export const IOS_SUPPORTED_NOT_SAFARI_VERSION = 14.3;
